import IconCompleted from 'Components/Atoms/IconCompleted/IconCompleted';
import OutlineArrowRight from 'Components/Atoms/OutlineIcons/OutlineArrowRight';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function FirstStepsGroupItem(props) {
    const { title, description, icon, onClick, completed, className, iconClassName } = props;

    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                'bg-white shadow-sm py-4 px-5 border rounded-xl w-full text-left group border-gray-200',
                completed && 'opacity-50 shadow-none hover:opacity-100 transition-opacity hover:shadow-sm',
                'focus:outline-none',
                className,
            )}
        >
            <div className="flex items-center gap-4">
                <div
                    className={cn(
                        'bg-gray-100 text-gray-600 size-8 flex items-center justify-center rounded-sm shrink-0',
                        iconClassName,
                    )}
                >
                    {icon}
                </div>
                <div className="grow">
                    <div className={cn('text-sm font-semibold text-dark-blue mb-0.5', completed && 'line-through')}>
                        {title}
                    </div>
                    <div className="text-xs text-gray-400">{description}</div>
                </div>
                {completed && (
                    <div className="translate-x-1 flex">
                        <IconCompleted isCompleted />
                    </div>
                )}
                {!completed && (
                    <div className="group-hover:translate-x-1 transition-transform flex">
                        <OutlineArrowRight size={24} color="currentColor" />
                    </div>
                )}
            </div>
        </button>
    );
}

FirstStepsGroupItem.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired,
    completed: PropTypes.bool,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
};
